import { TEST_BATCH_TYPE } from '../constants';
import type { GenerateAccuracyFormState } from '../state/generateAccuracyReducer';
import type { AccuracyBatchOption } from '../types/response';

export interface GenerateAccuracyValidation {
  batch: boolean;
  model: boolean;
  prompt: boolean;
  description: boolean;
  canGenerate: boolean;
}

/**
 * Pure and derived-only — there is no stored `isValid` flag to disagree with the
 * fields it summarises (see the design doc's "validation is derived, never stored").
 */
export const getGenerateAccuracyValidation = (
  state: GenerateAccuracyFormState,
  selectedBatch: AccuracyBatchOption | undefined
): GenerateAccuracyValidation => {
  const batch =
    Boolean(state.batchId) &&
    Boolean(selectedBatch?.isSelectableForAccuracy) &&
    (state.batchType !== TEST_BATCH_TYPE || state.testBatchAcknowledged);
  const model = Boolean(state.modelId);
  const prompt = Boolean(state.promptPath);
  const description = state.description.trim().length > 0;

  return {
    batch,
    model,
    prompt,
    description,
    canGenerate: batch && model && prompt && description,
  };
};
